import { useEffect, FunctionComponent } from 'react'
import { notifyRender } from 'libraries/front-end-core/services/WindowService'
import { updateBreakpoints } from 'services/AccordionService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import Xml from 'components/shared/Xml'
import useBaseState from 'hooks/useBaseState'
import ContentItemContainer from 'redux/containers/components/accordion/ContentItemContainer'
import { ContentContainerProps } from 'redux/containers/components/accordion/ContentComponentContainer'

const ContentComponent: FunctionComponent<ContentComponentProps> = (props) => {
  const {
    aol,
    path,
    content = '',
    subscribedContent,
    depth,
    title,
    eventCategory,
    flavour,
    id,
    hasAccess,
    caseRefMap
  } = props

  const { baseState } = useBaseState(props.state, { expanded: false, enableHighlight: 1, editing: 0 })
  const restrictedAccessClassName = hasAccess === false ? 'bg-moon-gray o-60' : ''

  useEffect(() => {
    updateBreakpoints()
    notifyRender(id)
  }, [])

  const renderContent = (): JSX.Element => {
    const [sectionId] = path

    if ((content === undefined || content === '') && subscribedContent !== undefined) {
      return (
        <ResponseConsumer
          response={subscribedContent}
          content={() => (
            <div className={restrictedAccessClassName}>
              <Xml
                component='div'
                className='content-text'
                render={subscribedContent}
                sectionId={sectionId}
                aol={aol}
                id={id}
                eventCategory={eventCategory}
                caseRefMap={caseRefMap}
              />
            </div>
          )}
        />
      )
    }
    // why has this gotten so complicated...
    const xmlContentMarginStyle = (depth: number, eventTypeCategory: string): { marginLeft: string } => {
      let marginLeft
      if (title === '' && eventTypeCategory !== 'Legislation') {
        marginLeft = `${((depth >= 3 ? depth : 3) - 3)}.8rem`
      } else if (eventTypeCategory !== 'Q&A') {
        marginLeft = `${depth}.75rem`
      } else {
        marginLeft = `${depth + 2}.75rem`
      }
      return ({ marginLeft })
    }

    return (
      <div className={`content ${restrictedAccessClassName}`}>
        <Xml
          component='div'
          styles={{ ...xmlContentMarginStyle(depth, eventCategory ?? ''), fontSize: '1rem' }}
          className='mr9 mr2-m content-text'
          render={content}
          sectionId={sectionId}
          aol={aol}
          id={id}
          eventCategory={eventCategory}
          caseRefMap={caseRefMap}
        />
      </div>
    )
  }

  return (
    <ContentItemContainer state={baseState} {...{ props, flavour, renderContent }} />
  )
}

interface ContentComponentProps extends ContentContainerProps {
  aol: string | string[]
  path: string[]
  id: string
  content?: string
  depth: number
  title: string
  eventCategory?: string
  subscribedContent?: string
  originalNode?: string
  state?: any
  hasAccess?: boolean
  caseRefMap?: Record<string, string>
}

export default ContentComponent
